import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { PhoneInput } from "@/interfaces/profile";

dayjs.extend(customParseFormat);

export const ProfileValidations = {
  required: (value: string) => (value ? null : "Champ requis"),
  requiredPhone: (value: PhoneInput) =>
    !value.isValid
      ? "Numéro invalide"
      : value.phoneNumber
      ? null
      : "Téléphone mobile requis",
  phone: (value: PhoneInput) => (value.isValid ? null : "Numéro invalide"),
  date: (value: string | null) =>
    value === null || value === ""
      ? null
      : dayjs(value, "DD/MM/YYYY", true).isValid()
      ? null
      : "Date invalide: JJ/MM/AAAA",
  requiredDate: (value: string | null) =>
    !dayjs(value, "DD/MM/YYYY", true).isValid()
      ? "Date invalide: JJ/MM/AAAA"
      : null,
};
